/**
 * 汇率管理API服务
 */

import api from './api';
import type {
    ExchangeRate,
    LatestRate,
    TrendData,
    FetchRatesRequest,
    FetchRatesResponse
} from '../types/exchange-rate-types';

/**
 * 汇率查询参数
 */
export interface GetRatesParams {
    base_currency?: string;
    target_currency?: string;
    date?: string;
}

/**
 * 最新汇率查询参数
 */
export interface GetLatestRatesParams {
    base?: string;
    currencies?: string;  // 逗号分隔，如 "USD,EUR,JPY"
}

/**
 * 趋势数据查询参数
 */
export interface GetTrendsParams {
    base?: string;
    currencies?: string;  // 逗号分隔
    days?: number;  // 天数
}

export const exchangeRateAPI = {
    /**
     * 获取汇率列表
     */
    getRates: (params?: GetRatesParams) =>
        api.get<ExchangeRate[]>('/exchange-rates/', { params }),

    /**
     * 获取单个汇率记录
     */
    getRate: (id: number) =>
        api.get<ExchangeRate>(`/exchange-rates/${id}/`),

    /**
     * 获取最新汇率
     */
    getLatestRates: (params?: GetLatestRatesParams) =>
        api.get<LatestRate[]>('/exchange-rates/latest/', { params }),

    /**
     * 获取趋势数据
     */
    getTrends: (params?: GetTrendsParams) =>
        api.get<TrendData[]>('/exchange-rates/trends/', { params }),

    /**
     * 手动触发汇率抓取
     */
    fetchRates: (data?: FetchRatesRequest) =>
        api.post<FetchRatesResponse>('/exchange-rates/fetch/', data || {}),
};
